import React from "react";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
import IconButton from "@material-ui/core/IconButton";

import alderLogo from "../../../../assets/img/alder-logo.png";
import styles from "../DownloadInventory.module.css";
import { Tooltip } from "@material-ui/core";
import { renderToString } from "react-dom/server";
import jsPDF from "jspdf";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));
const DownloadPartInventory = (props) => {
  const classes = useStyles();
  console.log("Generate PDF Page");
  const InvoiceHtml = (props) => {
    return (
      <div className={styles.container}>
        {console.log("hiiii")}
        {console.log(props.details)}
        <div className={styles.content}>
          <div className={styles.header}>
            <img src={alderLogo} alt="alder logo" />
            <div className={styles.contentright}>
              <h3>Alder Furniture Pvt Ltd</h3>
              <h3>
                27 Furniture Block, Kirti Nagar, New Delhi – 110015, INDIA
              </h3>
              <h3>
                website: www.alder.in, Email: info@alder.in | sales@alder.in
              </h3>
              <h3>Phone: +91-011-42903322</h3>
            </div>
          </div>
          <div className={styles.alignStart}>
            <p>Warehouse Part Inventory</p>
          </div>
          <div className={styles.alignStart}>
            <p>Warehouse Detail</p>

            <table className={styles.table} border="1">
              <thead className={styles.tableHeader}>
                <tr>
                  <th>Name</th>
                  <th>Bar Code</th>
                  <th>Address</th>
                  <th>Location</th>
                  <th>Contact Number</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{props.name ? props.name.name : "Nan"}</td>
                  <td>{props.name ? props.name.warehouse_barcode : "Nan"}</td>
                  <td>{props.name ? props.name.address : "Nan"}</td>
                  <td>{props.name ? props.name.warehouseLocation : "Nan"}</td>
                  <td>{props.name ? props.name.contactNum : "Nan"}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className={styles.alignStart}>
            <p>Parts Details</p>
            <table className={styles.table} border="1">
              <thead className={styles.tableHeader}>
                <tr>
                  <th>Name</th>
                  <th>Part unit Code</th>
                  <th>Height</th>
                  <th>Length</th>
                  <th>weight</th>
                  <th>width</th>
                  <th>status</th>
                  <th>GoDown</th>
                  <th>Location</th>
                </tr>
              </thead>

              <tbody>
                {props.details.map((items, index) => {
                  return (
                    <tr>
                      {items.map((subItems, sIndex) => {
                        return <td>{subItems}</td>;
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };
  const print = () => {
    const htmlString = renderToString(
      <InvoiceHtml details={props.details} name={props.name} />
    );

    const pdf = new jsPDF({
      orientation: "p",
      unit: "pt",
      format: "a3",
    });
    pdf.setTextColor(0, 0, 0);
    pdf.html(htmlString, {
      callback: function (pdf) {
        let filename = `parts details.pdf`;
        pdf.save(filename);
      },
    });
  };
  return (
    <React.Fragment>
      <Tooltip title="Download Parts details">
        <Button
          onClick={print}
          variant="contained"
          color="default"
          className={classes.button}
          startIcon={<GetAppRoundedIcon />}
        >
          Download Parts details
        </Button>
      </Tooltip>
    </React.Fragment>
  );
};
export default DownloadPartInventory;
